<section class="ml-28 mr-8 h-full">
  <div class="messagesGrid mt-5 mb-4 text-center">
    <div class="flex justify-center">
      <app-column-filter
        id="messagesDeliveryStatusFilter"
        [icon]="images.messages.successMessageSent"
        [label]="literalService.get('messages.data.deliveryStatus', true)"
        [loader]="deliveryStatusFilterSource.loader"
        [toOption]="deliveryStatusFilterSource.toOption"
        [searchable]="false"
        [selected]="filters().selectedDeliveryStatuses"
        (apply)="filterByDeliveryStatus($event)"
      />
    </div>
    <div class="flex justify-center">
      <app-column-filter
        id="messagesChannelFilter"
        [icon]="images.services.tag"
        [label]="literalService.get('messages.data.channel', true)"
        [loader]="channelFilterSource.loader"
        [toOption]="channelFilterSource.toOption"
        [searchable]="false"
        [selected]="filters().selectedChannels"
        (apply)="filterByChannels($event)"
      />
    </div>
    <label class="flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.messages.affair" alt="subject" class="h-6 w-6 mr-2" />
      {{ literalService.get("messages.data.subject", true) }}
    </label>
    <label class="flex justify-center col-span-3 font-semibold text-base">
      <img [src]="images.messages.from" alt="from" class="h-6 w-6 mr-2" />
      {{ literalService.get("messages.data.from", true) }}
    </label>
    <label class="flex justify-center col-span-3 font-semibold text-base">
      <img [src]="images.messages.receiver" alt="receiver" class="h-6 w-6 mr-2" />
      {{ literalService.get("messages.data.receiver", true) }}
    </label>
    <label class="flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.messages.date" alt="date" class="h-6 w-6 mr-2" />
      {{ literalService.get("messages.data.dateSent", true) }}
    </label>
    <span class="flex justify-center col-span-1">
      <img [src]="images.moreOptions" alt="" aria-hidden="true" class="h-6 w-6 filter-primary-purple-light" />
      <span class="sr-only">{{ literalService.get("moreOptions", true) }}</span>
    </span>
  </div>
</section>
<section>
  <div id="messagesContainer" class="scrollable-content h-[calc(100vh-310px)] ml-25 mr-5 px-3 mb-2 overflow-y-scroll" >
    @if (!messages()!.isFetchingMessages) {
      @for (message of messages()!.value; track message.id) {
        @let sentDate = message.dateTime | utcDateTime;
        @let deliveryStatus = message.deliveryStatus ?? (message.successful ? MessageStatus.SUCCESS : MessageStatus.FAILED);
        @let deliveryStatusIcon = deliveryStatusIcons[deliveryStatus];
        @let deliveryStatusDescription = `${literalService.get('messages.modal.details.title', true)}: ${literalService.get('messages.tooltips.' + deliveryStatus.toLowerCase() + 'MessagesSent')}`;
        <div
          [id]="`messages${message.id}`"
          class="messageRow messagesGrid selectable-row border rounded pt-2 pb-2 items-center mb-4"
          [class.selected-row]="message.id === selectedMessageId()"
        >
          <button
            type="button"
            class="flex justify-center items-center h-full focus-visible:outline-2 focus-visible:outline-primary-purple"
            [attr.aria-label]="deliveryStatusDescription"
            [tooltip]="deliveryStatusDescription"
            [position]="TooltipPosition.BELOW"
            (click)="showMessageDetail(message.id!)"
          >
            <img [src]="deliveryStatusIcon.src" alt="" aria-hidden="true" class="h-6 w-6" [class]="deliveryStatusIcon.filterClass" />
          </button>
          <a
            class="messageLink items-center no-underline text-inherit"
            [href]="`/messages/${userType()}/${message.id}`"
            (click)="openMessage($event, message.id!)"
          >
            @let channelsLabel = message.channels | messageChannelsLabel;
            <span class="flex justify-center items-center h-full" [tooltip]="channelsLabel" [position]="TooltipPosition.BELOW">
              <span class="sr-only">{{ channelsLabel }}</span>
              @if (message.channels && message.channels.length > 1) {
                <img [src]="images.messages.channel.multiple" alt="" aria-hidden="true" class="h-6 w-6" />
              } @else if (message.channels.includes(MessageChannel.EMAIL)) {
                <img [src]="images.messages.channel.email" alt="" aria-hidden="true" class="h-6 w-6" />
              } @else if (message.channels.includes(MessageChannel.PUSH_NOTIFICATION)) {
                <img [src]="images.messages.channel.pushNotification" alt="" aria-hidden="true" class="h-6 w-6" />
              } @else if (message.channels.includes(MessageChannel.SMS)) {
                <img [src]="images.messages.channel.sms" alt="" aria-hidden="true" class="h-6 w-6" />
              } @else if (message.channels.includes(MessageChannel.WHATSAPP)) {
                <img [src]="images.messages.channel.whatsApp" alt="" aria-hidden="true" class="h-6 w-6" />
              }
            </span>
            <span
              [id]="`subject-${message.id}`"
              class="truncate pr-3 pl-3 col-span-2 text-base"
              [tooltip]="utilsService.visibleTooltip(`subject-${message.id}`) ? message.subject! : ''"
              [visibleTooltip]="utilsService.visibleTooltip(`subject-${message.id}`)"
              [position]="TooltipPosition.DYNAMIC"
            >
              {{ message.subject }}
            </span>
            <span
              [id]="`from-${message.id}`"
              class="truncate pr-3 pl-3 col-span-3 text-base"
              [tooltip]="utilsService.visibleTooltip(`from-${message.id}`) ? getSenderLabel(message) : ''"
              [visibleTooltip]="utilsService.visibleTooltip(`from-${message.id}`)"
              [position]="TooltipPosition.DYNAMIC"
            >
              {{ getSenderLabel(message) }}
            </span>
            <span
              [id]="`to-${message.id}`"
              class="truncate pr-3 pl-3 col-span-3 text-base"
              [tooltip]="(utilsService.visibleTooltip(`to-${message.id}`) && message.receiverName) ? message.receiverName! : ''"
              [visibleTooltip]="utilsService.visibleTooltip(`to-${message.id}`)"
              [position]="TooltipPosition.DYNAMIC"
            >
              {{ literalService.get(`messages.receiver.${message.receiver!.toLowerCase()}`, true) }}@if (message.receiverName) { - {{ message.receiverName }} }
            </span>
            <span [id]="`dateSent-${message.id}`" class="truncate pr-3 pl-3 col-span-2 text-base">
              @if (sentDate) {
                <time
                  [attr.datetime]="sentDate | date: 'yyyy-MM-ddTHH:mm'"
                  [tooltip]="(sentDate | date: 'dd/MM/yyyy HH:mm') ?? ''"
                  [position]="TooltipPosition.BELOW"
                >
                  {{ sentDate | date: 'dd/MM/yyyy' }}<span class="sr-only"> {{ sentDate | date: 'HH:mm' }}</span>
                </time>
              } @else {
                -
              }
            </span>
          </a>
          <div class="flex justify-center items-center col-span-1">
            <app-message-redirect-button [message]="message" />
          </div>
        </div>
      }
    } @else {
      <ngx-skeleton-loader [count]="messages()?.pagination?.size || 10" appearance="line" [theme]="{ 'height': '40px' }"></ngx-skeleton-loader>
    }
  </div>
</section>
